module.exports = __webpack_public_path__ + "static/media/monkey.c51b524f.png";